export default __webpack_public_path__ + "static/media/roles-icon.303f9801.svg";